import TypeBenneFormController from './type.benne.form.controller';

export default {
    template: require('./type.benne.form.html'),
    controller: TypeBenneFormController
};
